import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import type { TableColumn } from '../../components/common/GenericTable';

export const credentialConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    listColumns: (options: ColumnOptions): TableColumn<any>[] => {
        const cols: TableColumn<any>[] = [
            {
                key: 'displayName',
                label: 'Name',
                title: 'DisplayName',
            },
            {
                key: 'domain',
                label: 'Domain',
                title: 'Domain',
            },
            {
                key: 'username',
                label: 'Username',
                title: 'Username',
                render: (entity: any) => {
                    const val = entity?.Username || entity?.rawData?.Username || '';
                    return val || null;
                },
            },
            {
                key: 'disabled',
                label: 'Status',
                title: 'Disabled',
                render: (entity: any) => {
                    const disabled = entity?.Disabled ?? entity?.rawData?.Disabled;
                    if (disabled === true) return Badge({ variant: 'filled', color: 'red', size: 'xs', children: 'Disabled' });
                    return Badge({ variant: 'filled', color: 'green', size: 'xs', children: 'Active' });
                },
            },
        ];

        if (!options.isStandard) {
            cols.push({
                key: 'isSystem',
                label: 'System',
                title: 'IsSystem',
                render: (entity: any) => {
                    const val = entity?.IsSystem ?? entity?.rawData?.IsSystem;
                    if (val !== true) return null;
                    return Badge({ variant: 'outline', color: 'gray', size: 'xs', children: 'System' });
                },
            });
        }

        return cols;
    },
};
